'use client';

/* ==================================================================
   Partner data — logos served from /public/new-logos/*.png
   `imgClass` is an optional optical-size override for a single logo.
   ================================================================== */

const partners = [
  { name: 'Red Hat', src: '/new-logos/redhat.png' },
  { name: 'Databricks', src: '/new-logos/databricks.png' },
  // Sprinto reads optically heavy, GeM optically light — nudge both so all
  // four logos carry the same visual weight inside the shared sizing box.
  { name: 'Sprinto', src: '/new-logos/sprinto.png', imgClass: 'max-h-[82%]' },
  { name: 'GeM', src: '/new-logos/gem.png', imgClass: 'max-h-full' },
];

/* ==================================================================
   Section
   ================================================================== */

export default function Partnerships() {
  return (
    <section data-nav-theme="light" className="relative bg-[#f6f8fb] py-24 lg:py-32">
      <div className="mx-auto w-11/12 max-w-[1280px]">
        <div className="grid items-center gap-12 lg:grid-cols-[5fr_7fr] lg:gap-16">
          {/* Left: intro */}
          <div>
            <h2 className="font-poppins text-4xl font-bold leading-[1.2] sm:leading-[1.2] lg:leading-[1.2] tracking-tight text-[#0a1b3a] sm:text-5xl lg:text-[3.25rem]">
              Partnerships
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-gray-600 lg:text-lg">
              We build on the platforms that make AI-first engineering dependable. From open infrastructure to security and compliance, these partnerships let us ship production-grade AI on foundations you can trust.
            </p>
          </div>

          {/* Right: 2 × 2 grid of partner logo cards */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            {partners.map(({ name, src, imgClass }) => (
              <article
                key={name}
                className="partner-card group flex h-32 items-center justify-center rounded-2xl border border-gray-200/80 bg-white p-5 shadow-[0_1px_2px_rgba(10,27,58,0.04)] transition hover:-translate-y-0.5 hover:border-[#058BF0]/40 hover:shadow-lg hover:shadow-cloud/5 lg:h-40 lg:p-6"
              >
                {/* Shared sizing box keeps every logo on the same optical baseline */}
                <div className="flex h-12 w-full items-center justify-center lg:h-14">
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src={src}
                    alt={`${name} logo`}
                    loading="lazy"
                    decoding="async"
                    className={`w-auto max-w-[70%] object-contain ${imgClass ?? 'max-h-full'}`}
                  />
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
